<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw TitlePage-rw exclude-print-rw" epub:type="frontmatter titlepage" id="BookTitlePage1">
<h1 class="titlr"><strong>HUNGRY HILL</strong></h1>
<h1 class="titlr1"><strong>Daphne du Maurier</strong></h1>
<h3 class="titlr2"><strong>Foreword by Nina Auerbach</strong></h3>
<p class="imglr"> </p>
<p class="img1"><img alt="images" src="images/Art_tit.jpg"/></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?2955d5d4